import React from "react";
const Corner = `${process.env.PUBLIC_URL}/corner.png`;
const Star = `${process.env.PUBLIC_URL}/star.png`;

export const Card = ({
	item,
}: {
	item: {
		value: string;
		pic: string;
		turned: boolean;
		matched: boolean;
		index: number;
		gameStarted: boolean;
	};
	id: number;
}) => {
	return (
		<div
			className={`memory-game-card ${item.turned || item.matched ? "visible" : ""}`}
		>
			<div className={"memory-game-card-back memory-game-card-face"}>
				<img className="corner corner-top-left" src={Corner} alt="" />
				<img className="corner corner-top-right" src={Corner} alt="" />
				<img className="corner corner-bottom-left" src={Corner} alt="" />
				<img className="corner corner-bottom-right" src={Corner} alt="" />
				<img className="star" src={Star} alt="" />
			</div>
			<div className={"memory-game-card-front memory-game-card-face"}>
				<img className="corner corner-top-left" src={Corner} alt="" />
				<img className="corner corner-top-right" src={Corner} alt="" />
				<img className="corner corner-bottom-left" src={Corner} alt="" />
				<img className="corner corner-bottom-right" src={Corner} alt="" />
				{item.pic ? (
					<img className="memory-game-card-value" src={item.pic} alt="" />
				) : (
					item.value
				)}
			</div>
		</div>
	);
};
